import {asMap} from '@shared/lib/utils/type_utils';

import {Account, setAccount} from '@mavismart_frontend/stores/account_store';
import {clearAccount} from '@mavismart_frontend/stores/account_store';
import {clearAllDoors} from '@mavismart_frontend/stores/all_doors_store';
import {clearDoorIds} from '@mavismart_frontend/stores/door_ids_store';
import {clearGroups, fetchGroups} from '@mavismart_frontend/stores/groups_store';
import {clearLoginInfo} from '@mavismart_frontend/stores/login_info_store';
import {fetchHasUnreadNotifications} from '@mavismart_frontend/stores/notifications_store';

export const initStores = (maybeAccount?: Account) => {
  const account = maybeAccount ?? (asMap(window, {})['account'] as Account | undefined);
  if (account !== undefined) {
    setAccount(account);
    fetchGroups();
    fetchHasUnreadNotifications();
  }
};

export const resetStores = () => {
  clearDoorIds();
  clearLoginInfo();
  clearAccount();
  clearGroups();
  clearAllDoors();
};
